import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import MarkdownViewer from './components/MarkdownViewer';
import ScribeEmbed from './components/ScribeEmbed';
import helpConfig from '../../content/help/config.json';
import { HelpConfig } from '../../types/Help';

const config = helpConfig as HelpConfig;

export default function HelpPage() {
  const { categoryId, pageId } = useParams<{ categoryId: string; pageId: string }>();

  if (!categoryId || !pageId) {
    return <div>Invalid page parameters</div>;
  }

  const category = config.categories.find((cat) => cat.id === categoryId);
  if (!category) {
    return <div>Category not found</div>;
  }

  const page = category.pages.find((p) => p.id === pageId);
  if (!page) {
    return <div>Page not found</div>;
  }

  document.title = `${page.title} | Wilma Help `;

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      {/* Breadcrumb */}
      <nav className="mb-6 text-sm text-gray-600">
        <Link to="/help" className="hover:text-wilma-600">
          Help
        </Link>
        <span className="mx-2">/</span>
        <Link to={`/help/${categoryId}`} className="hover:text-wilma-600">
          {category.title}
        </Link>
        <span className="mx-2">/</span>
        <span className="text-wilma-600">{page.title}</span>
      </nav>

      {/* Page Title */}
      <h1 className="text-3xl font-bold mb-6 text-wilma-600">{page.title}</h1>

      {/* Scribe Embed (if available) */}
      {page.scribeId && (
        <ScribeEmbed scribeId={page.scribeId} title={`Watch: ${page.title}`} />
      )}

      {/* Markdown Content */}
      <div className="mt-6">
        <MarkdownViewer markdownPath={page.markdown} />
      </div>
    </div>
  );
}

